import React, {useEffect, useMemo, useState, useCallback, useRef} from 'react';
import 'devextreme-react/text-area';
import dxButton from "devextreme/ui/button";
import {Popup} from 'devextreme-react/popup';
import {Button} from 'devextreme-react/button';
import DataGrid, {Editing, Item, Lookup} from "devextreme-react/data-grid";
import {CheckBox} from 'devextreme-react/check-box';
import {Column, MasterDetail} from 'devextreme-react/data-grid';
import TabPanel, {Item as TabItem} from "devextreme-react/tab-panel";
import Toolbar, {Item as ToolbarItem} from "devextreme-react/toolbar";
import Form, {GroupItem, Label, SimpleItem, ButtonItem, FormRef, EmptyItem} from "devextreme-react/form";
import {DateBox, Button as DateBoxButton} from 'devextreme-react/date-box';
import {NumberBox} from 'devextreme-react/number-box';
import useCustomDataSource, {IFormBaseDataSourceOptions, Mode} from "../../hooks/useCustomDataSource";
import "./gestion-facturation.css"
import {useDateInput} from '../../components/inputs';
import useUsager from '../../components/selectbox/usager';
import {FormListBase, FormListBaseGrid, FormListBaseToolbar} from '../base';
import useClient from "../../components/selectbox/client";
import formatTelephone from "../../utils/format-telephone";
import useLookUpBase from "../../components/selectbox/LookupBase";
import useApi from "../../hooks/useApi";
import Guid from "../../models/Guid";
import IGestionFacturation from "../../models/IGestionFacturation";
import GestionFacturationDetail from "./gestion-facturation-detail";
import GestionFacturationSommaire from "./gestion-facturation-sommaire";
import IFacturationList from "../../models/IFacturationList";
import IClient from "../../models/IClient";
import {differenceInCalendarYears, format} from "date-fns";
import FormSysteme from "../../components/forms/form-systeme";
import IReservationEntete from "../../models/IReservationEntete";
import ListProduitDisponible from "../gestion-reservations/list-produit-disponible";
import "./gestion-facturation.css";
import PopupPage from "../../components/popups/PopupPage";
import GestionPaiement from "../gestion-paiement/gestion-paiement";
import {TypeAuxiliaire} from "../../models/TypeAuxiliaire";
import IGestionReservation from "../../models/IGestionReservation";
import * as linkSlashSvg from '../../images/link-slash.svg'
import GestionReservations from "../gestion-reservations/gestion-reservations";
import IMessage from "../../models/IMessage";
import {PopupTypeMessage} from "../gestion-reservations/popup-type-message";
import ImpressionConfirmation from "../gestion-reservations/impression-confirmation";
import ImpressionFacture from "./impression-facture";
import {IItemOptions} from "../base/form-list-base-toolbar";
import {useAuth} from "../../contexts/auth";

interface IGestionFacturationProps {
    idFacturationEntete?: Guid
}


export default function GestionFacturation({idFacturationEntete}: IGestionFacturationProps) {
    const [tabPanelConfig, setTabPanelConfig] = useState(
        {
            animationEnabled: true,
            swipeEnabled: true,
            loop: false,
            selectedIndex: 0,
        }
    )
    const linkSlash = linkSlashSvg.default;
    const facturationDataSourceOption: IFormBaseDataSourceOptions = useMemo(() => ({
        path: "facturation",
        customReadByIdPath: "facturation/{key}/gestion",
        customSauvegarderPath: "facturation/save",
        primaryKey: "idFacturationEntete",
        defaultId: idFacturationEntete
    }), [idFacturationEntete])

    const {user} = useAuth();
    const {fetchData} = useApi<IGestionFacturation>("facturation");
    const [dateValue, setDateValue] = useState(new Date());
    const {getData: getDefaultMessage} = useApi<IMessage>("message");
    const {usager, usagerEditorOptions, getUsagerNamebyId} = useUsager();
    const {dateOptions: dateTimeOptions} = useDateInput(true);
    const formRef = useRef<FormRef>(null);
    const {clientEditorOptions, currentClient, PopupGestionClient} = useClient(true);
    const [isPopupVisibleDepot, setPopupVisibilityDepot] = useState(false);
    const [isPopupVisibleReservation, setPopupVisibilityReservation] = useState(false);
    const [idMessageImpressionFacture, setIdMessageImpressionFacture] = useState<Guid | undefined>()
    const [isPopupVisibleMessageFacture, setIsPopupVisibleMessageFacture] = useState(false);
    const [isPopupVisibleFacture, setIsPopupVisibleFacture] = useState(false);
    const {editorOptions: contratEditorOptions} = useLookUpBase({controllerName: "contratDefinition"});
    const togglePopupDepot = () => {
        setPopupVisibilityDepot(prev => !prev);
    };
    useEffect(() => {
        if (!currentClient) return;
        setSelectedFacture(prev => {
            return {...prev, client: currentClient} as IGestionFacturation
        })
    }, [currentClient]);

    useEffect(() => {
        const mainFormInstance = formRef?.current?.instance();
        if (mainFormInstance)
            setMainForm(mainFormInstance);
    }, [formRef?.current])

    const facturationFormDataSource = useCustomDataSource<IFacturationList, IGestionFacturation>(facturationDataSourceOption);
    const {
        selectedDataRow: selectedFacture,
        mode,
        setMode,
        onFieldDataChanged,
        setMainForm,
        setIsFieldModifier,
        setSelectedDataRow: setSelectedFacture
    } = facturationFormDataSource;

    const onPopupDepotClose = (currentId: Guid | undefined) => {
        setPopupVisibilityDepot(false)
        if (currentId) {
            facturationFormDataSource?.dataSource?.store().byKey(currentId);
        }
        facturationFormDataSource?.dataSource?.reload()
    };

    const reservationOptions = useMemo(() => {
        return {
            readOnly: true,
            buttons: [
                {
                    name: 'Reservation',
                    location: 'after',
                    options: {
                        icon: 'search',
                        stylingMode: "text",
                        disabled: false,
                        onClick: () => {
                            setPopupVisibilityReservation(true);
                        },
                        style: {margin: 0}
                    },
                },
                {
                    name: 'delier',
                    location: 'after',
                    options: {
                        icon: linkSlash,
                        stylingMode: "text",
                        disabled: false,
                        style: {margin: 0},
                        onClick: () => {
                        }
                    }
                }
            ],
        }
    }, []);

    const gridColClientOptions = useMemo(() => {
        return {with: "fit-content"};
    }, []);

    const ajouterOptions = useMemo<IItemOptions>(() => ({
        text: "Ajouter",
        icon: "plus",
        click: (e: any) => {
            fetchData("get", {customPath: `facturation/default`}).then((data) => {
                setSelectedFacture({
                    ...data,
                    //dateDeVente: new Date(),
                    idUsagerCreation: user?.idUsager,
                    idUsagerModification: user?.idUsager
                });
                setMode(Mode.Ajout);
            })
        }
    }), [fetchData, setSelectedFacture, user?.idUsager, setMode])

    const soldeCalculateCellValue = useCallback((e: IFacturationList) => e.montantFacture - e.montantPaye, []);
    return (
        <>
            <FormListBase data={facturationFormDataSource}>
                <FormListBaseToolbar headerText={`Facture #${selectedFacture?.noFacture} - ${selectedFacture?.client?.prenom} ${selectedFacture?.client?.nom}`} sauvegarderOptions={{disabled: false}}
                                     annulerOptions={{disabled: false}} ajouterOptions={ajouterOptions}>
                    <Item key={"toolbar-item-renverser-facture"} location={"before"} widget={"dxButton"}
                          locateInMenu={"auto"}
                          options={{icon: 'minus', text: "Renverser Facture", onClick: () => console.warn()}}/>
                    <Item key={"toolbar-item-depart"} location={"before"} widget={"dxButton"} locateInMenu={"auto"}
                          options={{icon: 'export', text: "Départ", onClick: () => console.warn()}}/>
                    <Item key={"toolbar-item-enregistrement"} location={"before"} widget={"dxButton"}
                          locateInMenu={"auto"}
                          options={{icon: 'textdocument', text: "Enregistrement", onClick: () => console.warn()}}/>
                    <Item key={"toolbar-item-transfert-reservation"} location={"before"} widget={"dxButton"}
                          locateInMenu={"auto"}
                          options={{icon: 'collapse', text: "Tranfert réservation ", onClick: () => console.warn()}}/>
                    <Item key={"toolbar-item-paiement"} location={"before"} widget={"dxButton"} locateInMenu={"auto"}
                          options={{icon: 'money', text: "Paiement", onClick: () => togglePopupDepot()}}/>
                    <Item key={"toolbar-item-imprimer"} location={"before"} widget={"dxButton"} locateInMenu={"auto"}
                          options={{
                              icon: 'print', text: "Imprimer", onClick: async () => {
                                  const message = await getDefaultMessage({customPath: "message/getDefaultMessage/c", returnOnly: true});
                                  setIdMessageImpressionFacture(message.idMessage)
                                  setIsPopupVisibleMessageFacture(true)
                              }
                          }}/>
                </FormListBaseToolbar>
                <FormListBaseGrid dataSource={facturationFormDataSource.dataSource}>
                    <Column key={"grid-col-no-facture"} cssClass={"grid-col-no-confirmation"} dataType={"string"}
                            dataField={"noFacture"} caption="No Facture"/>
                    <Column key={"grid-col-client"} cssClass={"grid-col-client"} dataField={"idClient"}
                            dataType={"object"} caption="Client" editorOptions={gridColClientOptions}>
                        <Lookup {...clientEditorOptions}/>
                    </Column>
                    <Column key={"grid-col-date-vente"} cssClass={"grid-col-date-debut"} dataField={"dateDeVente"}
                            dataType={"date"} caption="Date facturation"/>
                    <Column key={"grid-col-telephone"} dataField={"telephone"} dataType={"string"} caption="Téléphone"/>
                    <Column key={"grid-col-montant"} dataField={"montantFacture"} dataType={"number"} caption="Montant"
                            format={"#0.00 $"}/>
                    <Column key={"grid-col-solde"} dataType={"number"} caption="Solde" format={"#0.00 $"}
                            calculateCellValue={soldeCalculateCellValue}/>
                    <Column key={"grid-col-reference"} dataType={"string"} caption="Référence" dataField={"reference"}/>
                </FormListBaseGrid>
                <div className={"gestion-facturation"} style={{display: "flex", height: "100%", gap: "1rem", width: "100%"}}>
                    <div>
                        <TabPanel scrollingEnabled={true} showNavButtons={true} height={"100%"} width={"14rem"}>
                            <TabItem title={'Produits'}>
                                <ListProduitDisponible isModeModify={mode === Mode.Modifier}/>
                            </TabItem>
                        </TabPanel>
                    </div>
                    <div style={{flex: 1}}>
                        <TabPanel>
                            <TabItem title="Informations">
                                <div style={{padding: "1rem"}}>
                                    <Form ref={formRef} colCount={8} readOnly={mode === Mode.Lecture} formData={selectedFacture} labelLocation={"left"} alignItemLabels={false} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
                                        <GroupItem caption={"Client"} colSpan={2}>
                                            <GroupItem colCount={4} alignItemLabels={false}>
                                                <SimpleItem cssClass={"client-label-style"} colSpan={3}
                                                            dataField={"idClient"}
                                                            editorType={"dxSelectBox"}
                                                            editorOptions={clientEditorOptions}>
                                                    <Label text={"Nom"}/>
                                                </SimpleItem>
                                                <SimpleItem>
                                                    <Button

                                                        text="Factures dues"
                                                        type={"default"}
                                                        onClick={() => console.warn()}/>
                                                </SimpleItem>
                                            </GroupItem>
                                            <GroupItem alignItemLabels={false}>
                                                <SimpleItem dataField={"client"} render={(e) => <div>{`${selectedFacture.client?.adresse}, ${selectedFacture.client?.ville}, ${selectedFacture.client?.codePostal}`}</div>}>
                                                    <Label text={"Adresse"}/>
                                                </SimpleItem>
                                                <SimpleItem dataField={"client"} render={(e) => <div>{selectedFacture?.client?.dateNaissance ? differenceInCalendarYears(Date(), selectedFacture?.client?.dateNaissance) : '-'}</div>}>
                                                    <Label text={"Âges"}/>
                                                </SimpleItem>
                                                <SimpleItem dataField={"client.telephone1"} render={(e) => <div> {selectedFacture?.client?.telephone1}</div>}>
                                                    <Label text={"Téléphone"}/>
                                                </SimpleItem>
                                            </GroupItem>
                                        </GroupItem>
                                        <GroupItem caption={"Informations"} colSpan={4} colCount={5}>
                                            <GroupItem colSpan={4}>
                                                <GroupItem colCount={4}>
                                                    <GroupItem colSpan={2}>
                                                        <SimpleItem editorType={"dxDateBox"} editorOptions={{displayFormat: "dd/MM/yyyy HH:mm"}} dataField={"dateDeVente"}>
                                                            <Label text={"Date de facturation"}/>
                                                        </SimpleItem>
                                                        <SimpleItem dataField={"reservation.reservationEntete.noConfirmation"} editorOptions={reservationOptions} visible={!selectedFacture?.idReservationEntete?.equals(Guid.empty)}>
                                                            <Label text={"Réservation # "}/>
                                                        </SimpleItem>
                                                    </GroupItem>
                                                    <GroupItem colSpan={2} alignItemLabels={false}>
                                                        <SimpleItem dataField={'reference'}>
                                                            <Label text={"Référence"}/>
                                                        </SimpleItem>
                                                        <SimpleItem dataField={"contrat"} editorType={"dxSelectBox"} editorOptions={contratEditorOptions}/>
                                                        <SimpleItem render={() => <div style={{display: "flex", flexDirection: "row", gap: "1rem"}}>
                                                            <div style={{whiteSpace: "nowrap", width: "10rem"}}>Mise à jour: {selectedFacture?.maj}</div>
                                                            <div>Z: {selectedFacture?.z}</div>
                                                        </div>}>
                                                        </SimpleItem>
                                                    </GroupItem>
                                                </GroupItem>
                                                <GroupItem>
                                                    <GroupItem colCount={2} visible={!selectedFacture?.idReservationEntete?.equals(Guid.empty)}>
                                                        <GroupItem>
                                                            <SimpleItem render={() =>
                                                                <div>{selectedFacture?.reservation ? format(selectedFacture?.reservation?.dateArrivee, "yyyy/MM/dd hh:mm") : null}</div>}>
                                                                <Label text={"Date d'arrivée"}/>
                                                            </SimpleItem>
                                                            <SimpleItem render={() =>
                                                                <div>{selectedFacture?.reservation ? format(selectedFacture?.reservation?.dateDepart, "yyyy/MM/dd hh:mm") : null}</div>}>
                                                                <Label text={"Date de départ"}/>
                                                            </SimpleItem>
                                                        </GroupItem>
                                                        <GroupItem>
                                                            <SimpleItem render={() =>
                                                                <div>{!selectedFacture.idAuxiliaire?.isEmpty() ? getUsagerNamebyId(selectedFacture?.idUsagerCreation) : null}</div>}>
                                                                <Label text={"Arrivée saisi par"}/>
                                                            </SimpleItem>
                                                            <SimpleItem render={() =>
                                                                <div></div>}>
                                                                <Label text={"Départ saisi par"}/>
                                                            </SimpleItem>
                                                        </GroupItem>
                                                    </GroupItem>
                                                </GroupItem>
                                            </GroupItem>
                                            <SimpleItem dataField={"saison"}/>
                                        </GroupItem>
                                        <GroupItem caption={"Notes"} colSpan={2}>
                                            <SimpleItem dataField={"note"} editorType={"dxTextArea"}>
                                                <Label visible={false}/>
                                            </SimpleItem>
                                        </GroupItem>
                                        <GroupItem colSpan={8} colCount={5}>
                                            <GroupItem caption={'Détails de la facture'} colSpan={4}>
                                                <GestionFacturationDetail {...facturationFormDataSource}/>
                                            </GroupItem>
                                            <GroupItem>
                                                <GroupItem caption={'Sommaire de la facture'}>
                                                    <GestionFacturationSommaire gestionFacturation={selectedFacture}/>
                                                </GroupItem>
                                            </GroupItem>
                                        </GroupItem>
                                    </Form>
                                </div>
                            </TabItem>
                            <TabItem title="Système">
                                <FormSysteme formData={selectedFacture}/>
                            </TabItem>
                        </TabPanel>
                    </div>
                </div>
            </FormListBase>
            <PopupPage<Guid>
                titre="Dépôt"
                isPopupOpen={isPopupVisibleDepot}
                onClose={(value) => onPopupDepotClose(value)}
                mode={"ajout"}
                height={"60%"}
                width={"60%"}
            >
                <GestionPaiement id={selectedFacture?.idFacturationEntete}
                                 typeAuxiliaire={TypeAuxiliaire.Facture}
                                 idClient={selectedFacture?.idClient}
                                 montantAuxiliaireTotal={(selectedFacture?.montantFacture || 0)}/>
            </PopupPage>
            <PopupPage mode={"ajout"} titre={"Gestion réservation"} isPopupOpen={isPopupVisibleReservation} height={"100%"} width={"100%"} onClose={() => setPopupVisibilityReservation(false)}>
                <GestionReservations idReservationEntete={selectedFacture?.reservation?.reservationEntete.idReservationEntete} collapseListe={true}/>
            </PopupPage>
            <PopupGestionClient isModeSelection={mode !== Mode.Lecture} onSelectionchanged={(selectedClient) => {
                setIsFieldModifier(true);
                setSelectedFacture((prev: any) => {
                    return {
                        ...prev,
                        idClient: selectedClient.idClient
                    }
                })
            }}/>
            {isPopupVisibleMessageFacture ? <PopupTypeMessage idMessageConfirmation={idMessageImpressionFacture} typeMessage={"f"} onClose={() => setIsPopupVisibleMessageFacture(false)} onConfirme={(idMessage: Guid) => {
                setIdMessageImpressionFacture(idMessage);
                setIsPopupVisibleMessageFacture(false);
                setIsPopupVisibleFacture(true);
            }}/> : null}
            {isPopupVisibleFacture ? <ImpressionFacture idMessage={idMessageImpressionFacture} idFacturationEntete={selectedFacture?.idFacturationEntete} onClose={() => {
                setIsPopupVisibleFacture(false)
                setIdMessageImpressionFacture(undefined);
            }}/> : null}
        </>
    )
}